import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function ValueStackSection() {
  const contents = ['Desafíos familiares divertidos y económicos.', 'Momentos guiados de conexión emocional.', 'Espacios para escribir y guardar recuerdos eternos.'];
  return <section className="py-10 bg-white" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <FadeIn data-id="element-152">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-8" data-id="element-153">
            ¿QUÉ VAS A RECIBIR EXACTAMENTE?
          </h2>
        </FadeIn>

        <div className="flex flex-col lg:flex-row items-center gap-8 max-w-6xl mx-auto" data-id="element-154">
          <FadeIn direction="right" className="w-full lg:w-1/2" data-id="element-155">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-brand-100" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/gdoNaevVERZnpGkuzwxwbb/WhatsApp_Image_2026-04-05_at_18.28.17_(1).jpg" alt="Pack 100 Citas con mi Hijo e Hija" className="w-full h-auto object-cover" data-id="element-157" />
              <div className="absolute top-4 right-4 bg-brand-500 text-white font-bold py-1 px-3 rounded-full text-sm shadow-lg" data-id="element-158">
                Formato Digital PDF
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="left" className="w-full lg:w-1/2" data-id="element-159">
            <div className="space-y-5" data-id="element-160">
              <div data-id="element-161">
                <h3 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3" data-id="element-162">
                  <span className="bg-brand-100 text-brand-700 w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-163">
                    1
                  </span>
                  Libro Digital "100 Citas con mi Hija" 👧
                </h3>
              </div>

              <div data-id="element-164">
                <h3 className="text-2xl font-bold text-slate-900 mb-6 flex items-center gap-3" data-id="element-165">
                  <span className="bg-brand-100 text-brand-700 w-10 h-10 rounded-full flex items-center justify-center text-xl" data-id="element-166">
                    2
                  </span>
                  Libro Digital "100 Citas con mi Hijo" 👦
                </h3>
              </div>

              <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-167">
                <h4 className="font-bold text-slate-900 text-lg mb-4" data-id="element-168">
                  Contenido de cada libro:
                </h4>
                <ul className="space-y-4" data-id="element-169">
                  {contents.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-170">
                      <CheckCircle2 className="w-6 h-6 text-brand-500 shrink-0 mt-0.5" data-id="element-171" />
                      <span className="text-slate-700 text-lg" data-id="element-172">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}